import { Drawer, DrawerHeader } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { FC, ReactNode } from "react";
import { TaskDueDateForm, TaskDueDateFormProps } from "../TaskDueDateForm";

export interface TaskDueDateFormDrawerProps
  extends Omit<TaskDueDateFormProps, "onClose"> {
  isOpen: boolean;
  title?: ReactNode;
  onClose: () => void;
}

/**
 * Mobile-first version of `TaskDueDateFormPopover`.
 * Renders the same content as a bottom drawer instead of an anchored popover.
 */
export const TaskDueDateFormDrawer: FC<TaskDueDateFormDrawerProps> = ({
  isOpen,
  title,
  onClose,
  ...props
}) => {
  const { t } = useTranslations();

  const defaultTitle = t({
    id: "tasks-page.due-date",
    defaultMessage: "Due date",
  });

  return (
    <Drawer
      isOpen={isOpen}
      placement="bottom"
      size="auto"
      onClose={onClose}
      className="flex max-h-[85dvh] w-full flex-col overflow-y-auto rounded-t-2xl px-4 pt-4 pb-8"
    >
      <TaskDueDateForm
        {...props}
        onClose={onClose}
        renderStartSlot={({ currentScreenTitle, canMoveBack, onMoveBack }) => (
          // Cancel out the drawer's own padding so the header can render
          // full-bleed, then restore a gap before the form content below it
          <div className="-mx-4 -mt-4 mb-4">
            <DrawerHeader
              type="title"
              title={canMoveBack ? currentScreenTitle : (title ?? defaultTitle)}
              onGoBack={canMoveBack ? onMoveBack : undefined}
              onClose={onClose}
            />
          </div>
        )}
      />
    </Drawer>
  );
};
